// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"622":"9f431778","750":"e5d581d3"}[chunkId] + ".chunk.js";
};